export default __webpack_public_path__ + "static/media/vr-pin-black.1f3a5928.svg";